const SITE_TITLE =
  'Vantix Credit Solutions | Restauración de crédito para hispanos en EE. UU. y Puerto Rico'
const SITE_DESCRIPTION =
  'Disputamos las cuentas inexactas, no verificables o mal reportadas en tu crédito. Diagnóstico gratuito con Eduardo Rodríguez. Servicio 100% remoto en español.'
const SITE_URL = 'https://vantixcreditsolutions.com/'
const SOCIAL_IMAGE =
  'https://cdn.magicpatterns.com/patterns/generated-images/a59def8c-45b3-43aa-b529-30814e60d78f.jpg'

function setMeta(selector: string, attribute: 'name' | 'property', key: string, content: string) {
  let element = document.head.querySelector<HTMLMetaElement>(selector)
  if (!element) {
    element = document.createElement('meta')
    element.setAttribute(attribute, key)
    document.head.appendChild(element)
  }
  element.content = content
}

function setCanonical(href: string) {
  let element = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]')
  if (!element) {
    element = document.createElement('link')
    element.rel = 'canonical'
    document.head.appendChild(element)
  }
  element.href = href
}

export function setSiteMetadata() {
  document.title = SITE_TITLE
  setMeta('meta[name="description"]', 'name', 'description', SITE_DESCRIPTION)
  setMeta('meta[property="og:title"]', 'property', 'og:title', SITE_TITLE)
  setMeta(
    'meta[property="og:description"]',
    'property',
    'og:description',
    SITE_DESCRIPTION,
  )
  setMeta('meta[property="og:image"]', 'property', 'og:image', SOCIAL_IMAGE)
  setMeta('meta[property="og:url"]', 'property', 'og:url', SITE_URL)
  setMeta('meta[property="og:type"]', 'property', 'og:type', 'website')
  setCanonical(SITE_URL)
}
